// TODO: mover componente a ats-app: Configuracion de etapa
import React, { useEffect, useState } from "react";
import { debounce } from "lodash-es";
import FormEditStep from "../form_edit_step/FormEditStep";
import { OrganizationDefaultColumnService } from "@frontend/src/core/services/organization_default_column_service";
import { openNotificationWithIcon } from "@frontend/src/utilities/notificationWithIcon";
import { TemplatesService } from "@frontend/src/core/services/templates_service";
import { commonsHelper } from "@frontend/helpers";
import { SelectionProcessesService } from "@frontend/src/core/services/selection_processes_service";
import { GeneralModal } from '@rankmi/ats-app'
import "./ModalEditStep.scss";

const metadata = {
  currentPage: 1,
  nextPage: null,
  prevPage: null,
  totalPages: 1,
  totalCount: 0,
};

const noData = {
  active: true,
  id: null,
  title: "Sin plantilla"
}

const ModalEditStep = ({
  isModalVisible,
  onCancelModal,
  column,
  organizationId,
}) => {
  const [currentColumn, setCurrentColumn] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [emailTemplates, setEmailTemplates] = useState([])
  const [userList, setUserList] = useState({
    data: [],
    pagination: metadata,
  });
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false); 
  const [searchTerm, setSearchTerm] = React.useState("");
  const organizationColumnService = new OrganizationDefaultColumnService();
  const selectionProcessesService = new SelectionProcessesService();
  const templatesService = new TemplatesService();
  useEffect(() => {
    handleOrganizationColumn();
    templatesService.getAll(organizationId, handleTemplateSettings, console.error);
  }, []);

  useEffect(() => {
    if (currentColumn) handleGetAllUsers(userList.pagination.currentPage);
  }, [currentColumn]);

  const initValues = {
    name: column?.name,
    order: column?.order,
    userColumnsActive: column?.user_columns_active,
    authorActive: column?.author_active,
    responsibleActive: column?.responsible_active,
    managersActive: column?.managers_active,
    enable_limit_applicants: column?.enable_limit_applicants,
    user_columns: column?.user_columns.map((item) => {
      return item.user_id;
    }),
    slaSetting: column?.sla_setting,
    applicant_requirements: column?.applicant_requirements,
    report_templates:
      column?.report_templates.length > 0
        ? column.report_templates[0].id
        : null,
    move_templates: column?.move_templates?.id,
    disqualify_templates:
      column?.disqualify_templates?.id,
    external_users:
      column?.external_users.length > 0
        ? column?.external_users.reduce(
            (prev, current, index) =>
              index == 0
                ? (prev += `${current.email}`)
                : (prev += `;${current.email}`),
            ""
          )
        : "",
  };

  const handleOrganizationColumn = () => {
    organizationColumnService.getById(
      column.id,
      (data) => {
        setCurrentColumn(data);
      },
      (err) => {}
    );
  };

  const handleTemplateSettings = (data) => {
    const user_profile = data?.user_profile ? [noData, ...data.user_profile] : [noData]
    const email = data?.emails ? [noData, ...data.emails]: [noData]
    setTemplates(user_profile)
    setEmailTemplates(email)
  }

  const handleGetAllUsers = (page, term) => {
    setLoading(true);
    selectionProcessesService
      .listUsers(
        currentColumn?.user_columns.map((item) => {
          return item.user_id;
        }),
        page,
        10,
        term,
        ""
      )
      .then(({ data, headers }) => {
        const mainData = {
          data,
          pagination: commonsHelper.buildMetadata(
            headers["current-page"],
            headers["total-pages"],
            headers["total-count"]
          ),
        };

        if (page > 1) {
          setUserList((value) => ({
            data: value.data.concat(mainData.data),
            pagination: mainData.pagination,
          }));
        } else {
          setUserList(mainData);
        }

        if (!term) {
          setUserList((value) => ({
            data: value.data.concat(
              mainData.data.filter((it) => selectedUsers.includes(it.id))
            ),
            pagination: mainData.pagination,
          }));
        }

        setLoading(false);
      });
  };

  const handleInfiniteScroll = ({
    target: { scrollHeight, scrollTop, clientHeight },
  }) => {
    const { nextPage } = userList.pagination;
    if (scrollHeight < scrollTop + clientHeight + 50 && nextPage && !loading) {
      searchTerm
        ? handleGetAllUsers(nextPage, searchTerm)
        : handleGetAllUsers(nextPage);
    }
  };

  const debouncedSearch = React.useCallback(
    debounce(handleGetAllUsers, 300),
    []
  );

  const onSearch = (term) => {
    setSearchTerm(term);
    term ? debouncedSearch(1, term) : setUserList(userList);
  };

  const handleSelect = (value) => {
    const selectedUserData = userList.data.find((item) => item.id === value);
    setSelectedUsers([...selectedUsers, selectedUserData]);
  };

  const handleDeselect = (value) => {
    const selectedUsersData = selectedUsers.filter((item) => item.id !== value);
    setSelectedUsers(selectedUsersData);
  };
  
  const onEditSubmit = (e, form) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      let columnData = {}
      setDisableSubmit(true);
      columnData['report_templates'] = [values.report_templates];
      columnData['external_users'] = values.external_users.length > 0 ? values.external_users.split(";") : []
      columnData['name'] = values.name
      columnData['user_columns'] = values.user_columns
      columnData['user_columns_active'] = values.user_columns_active
      columnData['responsible_active'] = values.responsible_active
      columnData['author_active'] = values.author_active
      columnData['managers_active'] = values.managers_active
      columnData['move_templates'] = values.move_templates
      columnData['disqualify_templates'] = values.disqualify_templates
      columnData['enable_limit_applicants'] = values.enable_limit_applicants
      columnData['sla_setting_attributes'] = {
        id: column?.sla_setting?.id,
        active: values.sla_count ? true : false,
        max_days: values.sla_count? values.sla_count : 0 
      }
      if (values.applicant_requirements) {
        columnData['applicant_requirements'] = values.applicant_requirements.map(
          (id) => ({
            value: values.applicant_requirement_value[id],
            condition: values.applicant_requirement_condition[id],
            required_type: 'relation_table',
            required_field: 'applicant_files'
          })
        );
      }
      
      organizationColumnService.edit(
        currentColumn.id,
        columnData,
        (data) => {
          setDisableSubmit(false);
          openNotificationWithIcon(
            "success",
            "Etapa actualizada correctamente",
            ""
          );
          setTimeout(() => { window.location.reload(false); }, 1000)
        },
        (err) => {}
      );
    });
  };

  return (
    <GeneralModal
      className="ModalEditStep"
      title="Editar etapa"
      visible={isModalVisible}
      onClose={onCancelModal}
    >
      <FormEditStep
        initValues={initValues}
        templates={templates}
        emailTemplates={emailTemplates}
        onSearch={onSearch}
        handleSelect={handleSelect}
        handleInfiniteScroll={handleInfiniteScroll}
        disableSubmit={disableSubmit}
        loading={loading}
        userList={userList}
        handleSubmitEdit={onEditSubmit}
        handleDeselect={handleDeselect}
      />
    </GeneralModal>
  );
};

export default ModalEditStep;
